import { SurveyQuestionResponse } from "./question";

export const BENCHMARKING_SCORE = 3.4;
export const BENCHMARKING_SCORE_002 = 2.97; // Inclusive Leadership
export const BENCHMARKING_SCORE_003 = 3.08; // Workplace Dynamics & Psychological Safety
export const BENCHMARKING_SCORE_004 = 4.14; // Authenticity & Masking

export interface DemographicGroup<T> {
  label: string;
  demographics: T[];
}

export interface GetSurveyChapterScoringResponse {
  chapters: SurveyChapterScoring[];
}

export interface SurveyChapterScoring {
  id: string;
  description: string;
  name: string;
  image: string | undefined;
  demographic: GetSurveyScoringDemographicResponse;
}
export interface GetSurveyScoringDemographicResponse {
  id?: string;
  name?: string;
  scores: GetSurveyScoringResponse;
}

export interface GetSurveyScoringResponse {
  total_score?: number;
  demographic_groups: SurveyScoringDemographicGroup[];
}

export interface SurveyScoringDemographicGroup {
  label: string;
  id: string;
  demographics: SurveyScoringDemographic[];
  is_combined: boolean;
}

export interface SurveyScoringDemographic {
  label: string;
  score?: number;
  id: string;
  is_scope: boolean;
  is_skip: boolean;
}
export interface GetQuestionBreakdownResponse {
  total_engagement: number;
  chapters: {
    id: string;
    questions: QuestionBreakdown[];
  }[];
}

export interface QuestionBreakdown
  extends Omit<SurveyQuestionResponse, "options" | "order"> {
  demographic_groups: QuestionBreakdownDemographicGroup[];
  total_responses: QuestionBreakdownDemographic;
}

export interface QuestionBreakdownDemographicGroup {
  label: string;
  demographics?: QuestionBreakdownDemographic[];
  is_custom: boolean;
  is_combined?: boolean;
  reference_id: string;
}

export interface QuestionBreakdownDemographic {
  label: string;
  engagement: number;
  options: QuestionBreakdownOptions[];
  combined_options: QuestionBreakdownCombinedOptions[];
  is_skip: boolean;
  reference_id: string;
}
export interface QuestionBreakdownOptions {
  count: number | null;
  is_skip: boolean;
  reference_id: string;
  text: string;
}

export interface QuestionBreakdownCombinedOptions {
  count: number | null;
  is_skip: boolean;
  option_ids: string[];
  text: string;
}

export interface QuestionBreakdownFilterOptions {
  count: number | null;
  is_skip: boolean;
  option_ids?: string[];
  reference_id?: string;
  text: string;
}
export interface GetSurveyDemographicResponse {
  engagement: number;
  demographic_groups?: DemographicGroup<SurveyDemographic>[];
}
export interface SurveyDemographic {
  id: string;
  label: string;
  engagement?: number;
  engagement_percent?: number;
}

export interface SurveyChapterInsight {
  id: string;
  dispatch_id: string;
  chapter_id: string;
  insight: string;
  order: number;
  percentage: number;
  benchmark_percentage: number;
  question_id: string;
}

export type GetSurveyChapterInsightResponse = SurveyChapterInsight[];

export interface GetDemographicGroupsResponse {
  intersect_demographics: any[];
  demographic_groups: DemographicGroupWithDetails[]; // TODO: rename to DemographicGroup when we stop using the scoring and engagement endpoints
}

export interface DemographicGroupWithDetails {
  id: string;
  label: string;
  is_combined: boolean;
  demographics: Demographic[];
}

export interface DemographicChapterScore {
  id: string;
  title: string;
  score: number | null;
}

export interface Demographic {
  id: string;
  label: string;
  score?: number | null;
  chapter_scores: DemographicChapterScore[];
  engagement: number;
  engagement_percent: number;
  is_skip: boolean;
  is_scope: boolean;
  is_under_threshold: boolean;
}
